// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import React from 'react';
import { withStyles } from "tss-react/mui";
import Loading from '@shared/components/Loading';

export interface LazyLoadProps {
  className?: string;
  withFallback?: boolean;
  component?: React.ComponentType<any>;
  children: React.ReactNode;
}

class LazyLoad extends React.Component<LazyLoadProps> {
  static defaultProps = {
    withFallback: true,
  };

  render() {
    const { component: Component, children, withFallback, ...otherProps } = this.props;
    const classes = withStyles.getClasses(this.props);

    return (
      <React.Suspense 
        fallback={withFallback
          ? <Loading classes={{ root: classes.root }} progressProps={{ size: 40 }} />
          : null
        }
      >
        {Component 
          ? <Component {...otherProps} />
          : children
        }
      </React.Suspense>
    );
  }
}

const LazyLoadStyled = withStyles(
  LazyLoad, 
  (theme, props) => ({
    "root": {},
  })
);

export default LazyLoadStyled;